import { updateObject } from 'utils/updateObject'
import { CLEAR, SET_DATA, SET_LOADING } from 'modules/Tickets/types'

const initialState = {
  loading: true,
}

const setTicketData = (state, { payload }) => updateObject(state, payload)

const toggleLoading = (state, { payload }) => updateObject(state, payload)

const clearTicketData = () => ({ ...initialState })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return toggleLoading(state, action)
    case SET_DATA:
      return setTicketData(state, action)
    case CLEAR:
      return clearTicketData(state)
    default:
      return state
  }
}

export default reducer
